import { Component, h } from '@stencil/core';

@Component({
  tag: 'zeudy-player-spinner',
  styleUrl: 'zeudy-spinner.scss',
  shadow: true,
})
export class zeudySpinner {
  render() {
    return <span part="base" class="spinner" aria-busy="true" aria-live="polite"></span>;
  }
}
